import { render } from "./ReminderPopup.vue?vue&type=template&id=0d0c9f23&scoped=true"
import script from "./ReminderPopup.vue?vue&type=script&lang=js"
export * from "./ReminderPopup.vue?vue&type=script&lang=js"

import "./ReminderPopup.vue?vue&type=style&index=0&id=0d0c9f23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0c9f23"]])

export default __exports__